import React from "react";
import vg from "../assests/2.webp.png";
import bg from '../assests/bg.png'
import heroImg from "../assests/6.png";
import { AiOutlineWhatsApp } from "react-icons/ai";


const Home = () => {
  
  return (
    <div className="background" style={{backgroundImage:`url(${bg})`,backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '100%'
    }}>
      <div className="home" id="home">
        <main>
          <div className="left">
            <h1>
            We are here to guide and build your <br />
              <span className="gradient">Ultimate</span> Career
              <br />
              
            </h1>
            <p>
              Connect with Like-Minded Individuals Expand Your Horizons Find
              Inspiration and Motivation Build Meaningful Relationships Access
              Exclusive Opportunities Make a Difference in the World
            </p>
          </div>
          <div className="img">
            <img src={heroImg} alt="" />
          </div>
        </main>
      </div>

      <section>
        <h1>
          Connect with <span className="gradient">Like Minded</span> Individuals
        </h1>
        <div className="container">
          <p>
            Kather community is a vibrant hub for people who share similar
            interests and passions. By joining this community, you will have
            access to a network of like-minded individuals who can offer
            support, advice, and guidance as you pursue your goals.
            <span class="whatsapp">
              <span className="gradient">Connect</span> with WhatsApp
              <a
                href="https://chat.whatsapp.com/HrjTlXYc0VlLXhKiZn9U58"
                target="blank"
              >
                <AiOutlineWhatsApp class="icon" />
              </a>
            </span>
          </p>
          <div className="img" >
            <img src={vg} alt="Graphics" />
          </div>
        </div>
      </section>
      <section>
        <h1>
          Why you should <span className="gradient">join</span> us?
        </h1>
        <div className="container ">
          <p class="width-full">
          Our mission is to help you discover your interests and passions, and guide you towards success. We'll connect you with the best mentors from your chosen industry and provide you with a comprehensive roadmap to achieve your goals. Whether you want to find a job or pursue freelancing or entrepreneurship, we'll support you every step of the way. Our program offers numerous opportunities to grow and become the best version of yourself, every day.
          </p>
        </div>
      </section>

      {/* <div className="home4" id="presence">
        <div>
          <h1>Presence</h1>

          <article>
            <div
              style={{
                animationDelay: "0.3s",
              }}
            >
              <a href="/" target="blank">
                <AiFillGoogleCircle style={{ color: "rgb(44,44,44)" }} />
              </a>
            </div>

            <div>
              <a
                href="https://chat.whatsapp.com/HrjTlXYc0VlLXhKiZn9U58"
                target="blank"
              >
                <AiOutlineWhatsApp style={{ color: "rgb(44,44,44)" }} />
              </a>
            </div>

            <div
              style={{
                animationDelay: "0.7s",
              }}
            >
              <AiFillYoutube />
            </div>

            <div
              style={{
                animationDelay: "0.9s",
              }}
            >
              <a
                href="https://instagram.com/kather.kath?igshid=YmMyMTA2M2Y="
                target="blank"
              >
                <AiFillInstagram style={{ color: "rgb(44,44,44)" }} />
              </a>
            </div>
          </article>
        </div>
      </div> */}
    </div>
  );
};

export default Home;
